import { render } from "./PaymentsGrid.vue?vue&type=template&id=4e0d8c52"
import script from "./PaymentsGrid.vue?vue&type=script&lang=js"
export * from "./PaymentsGrid.vue?vue&type=script&lang=js"

import "./PaymentsGrid.vue?vue&type=style&index=0&id=4e0d8c52&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__